import { __assign, __rest } from "tslib";
// TierPromotionCard the smartest - is aware of business logic and picks which CTA button to show
import React from 'react';
import c from 'classnames';
import TierPromotionCardSemiDumb from '../TierPromotionCardSemiDumb';
import { useTierPromotionCardCtaType } from './useTierPromotionCardCtaType';
import s from './TierPromotionCard.scss';
var TierPromotionCard = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick, ctaClassname = _a.ctaClassname, fakeCTAButton = _a.fakeCTAButton, verticalLayout = _a.verticalLayout, props = __rest(_a, ["deviation", "onClick", "ctaClassname", "fakeCTAButton", "verticalLayout"]);
    var ctaButton = useTierPromotionCardCtaType(deviation);
    if (!deviation.tier) {
        return null;
    }
    return (React.createElement(TierPromotionCardSemiDumb, __assign({ deviation: deviation, onClick: function () { return onClick && onClick(deviation); }, ctaButton: ctaButton, ctaClassname: c(ctaClassname, fakeCTAButton && s['fake-button']), verticalLayout: verticalLayout }, props)));
};
TierPromotionCard.displayName = 'TierPromotionCard';
export default TierPromotionCard;
//# sourceMappingURL=TierPromotionCard.js.map